/**
 * =============================================================================
 *  BANG DOI TUONG - danh sach nhung gi dang nam TREN trang dang xem
 * =============================================================================
 *
 *  Mo phong bang ben phai cua trinh soan ilovepdf: moi dong la mot doi tuong,
 *  bam de chon, doi cho len / xuong, xoa.
 *
 * =============================================================================
 *  THU TU TRONG BANG PHAI LA THU TU TRONG TEP - KHONG CHI LA GIAO DIEN
 * =============================================================================
 *  Trinh xem PDF ve /Annots theo DUNG thu tu mang. Neu bang nay sap xep theo
 *  mot tieu chi rieng (thoi diem tao, ten, ma) con duong ghi giu thu tu them
 *  vao, thi cai nguoi dung keo len tren o day se van nam duoi trong tep xuat ra.
 *  Do la mot ban xem truoc noi doi, va no la dung loai loi ma du an nay da tra
 *  gia hai vong o duong sua chu de hoc.
 *
 *  Nen chi co MOT nguon thu tu: truong `Annotation.z`. Kho trang thai giu mang
 *  `annotations` luon sap theo `z` (sortAnnotationsByZ), placeAnnotations() sap
 *  on dinh theo trang nen giu nguyen thu tu trong tung trang, va writeAnnotations()
 *  gan theo dung thu tu do. Bang nay chi DAO NGUOC lai de hien - tren cung cua
 *  bang la tren cung cua chong lop - chu khong sap xep lai gi.
 *
 * =============================================================================
 *  VI SAO KHONG CO DOI TEN
 * =============================================================================
 *  Nhan cua moi dong duoc SINH RA tu loai doi tuong va noi dung cua no. Mot o
 *  doi ten se can mot truong moi trong hop dong kieu, phai di qua tuan tu hoa
 *  va cong tac, va roi khong duoc ghi vao dau ca trong tep PDF (khong co khoa
 *  nao cho "ten do nguoi dung dat"). Mot cai ten chi song trong phien lam viec
 *  roi bien mat khi luu la mot loi hua bi be gay.
 */
import type { Annotation } from '@pdfeditor/types';
import { cssColor } from './textEditCore';
import { KIND_ICON, objectLabel } from './objectLabels';
import { objectRowsForPage } from './objectRows';

export interface ObjectPanelProps {
  /** Chu thich cua CA tai lieu, da sap theo z tang dan. */
  annotations: readonly Annotation[];
  /** Trang dang xem, theo chi so cua TAI LIEU GOC. null = khong loc duoc. */
  pageIndex: number | null;
  selectedId: string | null;
  onSelect: (id: string | null) => void;
  onReorder: (id: string, direction: 'up' | 'down') => void;
  onDelete: (id: string) => void;
}

export function ObjectPanel({
  annotations,
  pageIndex,
  selectedId,
  onSelect,
  onReorder,
  onDelete,
}: ObjectPanelProps) {
  // TREN CUNG CUA BANG = TREN CUNG CUA CHONG LOP. Quy tac nam trong
  // ./objectRows.ts de test kiem chung duoc no - o day chi hien.
  const rows = objectRowsForPage(annotations, pageIndex);

  return (
    <section className="objectPanel" aria-label="Đối tượng trên trang">
      <div className="objectPanelHeader">
        <span className="inspectorTitle">Đối tượng</span>
        <span className="objectCount">
          {pageIndex === null ? '—' : `${rows.length} trên trang ${pageIndex + 1}`}
        </span>
      </div>

      {rows.length === 0 ? (
        <p className="objectEmpty">
          Chưa có đối tượng nào trên trang này. Dùng Ghi chú, Hộp chữ hoặc Hình khối để thêm.
        </p>
      ) : (
        <ul className="objectList">
          {rows.map((a, index) => {
            const selected = a.id === selectedId;
            return (
              <li key={a.id}>
                <div className={`objectRow${selected ? ' selected' : ''}`}>
                  <button
                    type="button"
                    className="objectMain"
                    aria-pressed={selected}
                    title={a.contents ? a.contents : objectLabel(a)}
                    onClick={() => onSelect(selected ? null : a.id)}
                  >
                    <span
                      className="objectIcon"
                      aria-hidden="true"
                      style={{ color: cssColor(a.colorRgb) }}
                    >
                      {KIND_ICON[a.kind] ?? '◆'}
                    </span>
                    <span className="objectLabel">{objectLabel(a)}</span>
                  </button>
                  <div className="objectActions">
                    <button
                      type="button"
                      className="iconButton tiny"
                      // `index` la vi tri trong BANG (dao nguoc), nen dong dau
                      // bang la doi tuong tren cung va khong len duoc nua.
                      disabled={index === 0}
                      title="Đưa lên trên một bậc"
                      onClick={() => onReorder(a.id, 'up')}
                    >
                      ↑
                    </button>
                    <button
                      type="button"
                      className="iconButton tiny"
                      disabled={index === rows.length - 1}
                      title="Đưa xuống dưới một bậc"
                      onClick={() => onReorder(a.id, 'down')}
                    >
                      ↓
                    </button>
                    <button
                      type="button"
                      className="iconButton tiny danger"
                      title="Xóa đối tượng"
                      onClick={() => onDelete(a.id)}
                    >
                      ✕
                    </button>
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
}
